import { useContext } from "react";
import { DataTableSettingsContext } from "../DataTableSettingsContext";
import { DataTableSettings } from "@/types/dataTableSettings";

export const useDataTableSettings = <TData,>() =>
  useContext(
    DataTableSettingsContext as React.Context<DataTableSettings<TData>>,
  );
